import { MsgVisibilityOldEnum, UserLoginTypeEnum } from '@pdcplan/shared/enums';

import { DayMessage } from '@pdcplan/shared/api/Message';
import { Message } from '@pdcfrontendui/components';
import { currentLanguage } from '../currentLanguage';
import { DayMessageMap } from '../util/getChatKey';
import { isWithinInterval } from 'date-fns';

export function shouldShowAsUnread(message: DayMessage, userId: number) {
  if (!message.ReadWhen) {
    if (messageIsFromMe(message, userId)) {
      return false;
    }
    // If it's an internal message, or a message from an employee
    if (
      message.Visibility === MsgVisibilityOldEnum.planner ||
      message.FromKey.UserType === UserLoginTypeEnum.employee
    ) {
      return true;
    }
  }
  return false;
}

export function hasUnreadMessages(messages: DayMessage[], userId: number) {
  return messages.some((message) => shouldShowAsUnread(message, userId));
}

export function messageIsFromMe(message: DayMessage, userId: number) {
  // Make sure that we include check for UserType, since otherwise we would compare userIds from different database tables.
  return (
    message.FromKey.UserType === UserLoginTypeEnum.planner &&
    message.FromKey.UserId === userId
  );
}

export function dayMessageToMessage(
  message: DayMessage,
  userId: number
): Message {
  return {
    fromMe: messageIsFromMe(message, userId),
    text: message.MessageText,
    timestamp: message.SentWhen,
    sender: {
      key: `${message.FromKey.UserId}`,
      name:
        message.FromKey.UserType === UserLoginTypeEnum.planner
          ? `${message.FromName} (${currentLanguage.Planner.toLowerCase()})`
          : message.FromName,
    },
    privateText:
      message.Visibility === MsgVisibilityOldEnum.planner
        ? currentLanguage.InternalMessage
        : undefined,
    isUnread: shouldShowAsUnread(message, userId),
  };
}

export function countUnreadMessages(
  dayMessageMap: DayMessageMap,
  userId: number,
  from: Date,
  to: Date
) {
  let count = 0;
  for (const thread of Object.values(dayMessageMap)) {
    if (isWithinInterval(thread[0].Day, { start: from, end: to })) {
      count += thread.filter((message) =>
        shouldShowAsUnread(message, userId)
      ).length;
    }
  }
  return count;
}
